import { render, staticRenderFns } from "./_new_list.vue?vue&type=template&id=4fd16d59&scoped=true"
import script from "./_new_list.vue?vue&type=script&lang=js"
export * from "./_new_list.vue?vue&type=script&lang=js"
import style0 from "./_new_list.vue?vue&type=style&index=0&id=4fd16d59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd16d59",
  null
  
)

export default component.exports